import React from 'react'

type Props = {
  variant: 'success' | 'error' | 'warning' | 'unanswered',
  className?: string
}

export function Dot({ variant, className }: Props) {
  switch (variant) {
    case 'success':
      return <span className={`w-[12px] h-[12px] rounded-full bg-green mr-2 ${className}`} ></span>;
      break;
    case 'error':
      return <span className={`w-[12px] h-[12px] rounded-full bg-red mr-2 ${className}`}></span>;
      break;
    case 'warning':
      return <span className={`w-[12px] h-[12px] rounded-full bg-orange mr-2 ${className}`}></span>;
      break;
    case 'unanswered':
      return <span className={`w-[12px] h-[12px] rounded-full bg-gray-400 mr-2 ${className}`}></span>;
      break;
    default:
      return <span className={`w-[12px] h-[12px] rounded-full bg-green-600 mr-2 ${className}`} ></span>;
      break;
  }
}